/**
 * Icon names that aren't Material Symbols ligatures. The icon maps in this lib
 * (POI_KIND_META, AMENITY_ICONS, NEARBY_META, ACTIVITY_CATEGORY_META) can use
 * these in place of a ligature name; `@cnt-workspace/ui`'s `[cntSymbol]`
 * directive and `symbolHtml()` render them as inline SVG in the same style.
 */

/** Down arrow into a basin with side ledges, after CurbNTurf's poi-dump.svg. */
export const DUMP_STATION_ICON = 'cnt-dump-station';
